<syn-dropdown placement="bottom-end" [distance]="8">

  <!-- Trigger: globe icon + current language code
       Uses currentColor so it inherits the header's icon color in both light and dark themes -->
  <button
    slot="trigger"
    type="button"
    class="flex items-center gap-1.5 px-2 py-1 rounded transition-colors border-0 bg-transparent cursor-pointer"
    style="color: currentColor; outline: none;"
    [attr.aria-label]="'header.changeLanguage' | translate"
  >
    <syn-icon name="language" style="font-size: 1.25rem; color: inherit"></syn-icon>
    <span class="text-sm font-semibold uppercase tracking-wide" style="color: inherit">
      {{ activeLanguage | uppercase }}
    </span>
  </button>

  <!-- Panel: language list -->
  <syn-menu style="min-width: 140px">
    @for (option of languageOptions; track option.name) {
      <syn-menu-item (click)="changeLanguage(option.name)">
        <span slot="prefix" class="flex items-center">
          <img
            [src]="'/assets/images/languages/' + option.country.code + '.png'"
            [alt]="option.country.name"
            class="w-5 h-5 rounded-full object-cover"
          />
        </span>
        <span [style.color]="option.selected ? 'var(--syn-color-primary-600)' : 'inherit'" [style.font-weight]="option.selected ? '700' : '400'">
          {{ option.name | uppercase }}
        </span>
        @if (option.selected) {
          <syn-icon slot="suffix" name="check" aria-hidden="true"></syn-icon>
        }
      </syn-menu-item>
    }
  </syn-menu>

</syn-dropdown>
